import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent],
  selector: 'aux-payments',
  templateUrl: './payments.component.html',
})
export class PaymentsComponent {
  private readonly launchDarklyService = inject(LaunchDarklyService);

  indexFn = generateCustomIndexFn(
    `${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.PAYMENTS.INDEX}`
  );
  tabs: TabGroupConfig[] = [
    {
      label: 'Payment Milestones',
      route: ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_MILESTONES,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.tab_payment_milestones)),
    },
    {
      label: 'Payment Schedule',
      route: ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_SCHEDULE,
      show: toObservable(
        this.launchDarklyService.$select((flags) => flags.tab_budget_payment_schedule)
      ),
    },
  ];
}
